export const movieList = [
  {
    id: "movie-1",
    title: "流浪地球3",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "科幻 / 冒险",
    duration: "148分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20poster%20with%20earth%20in%20space%20and%20giant%20engines%2C%20dramatic%20lighting%2C%20orange%20and%20dark%20tones%2C%20cinematic%20poster%20design&width=600&height=840&seq=poster-movie-1&orientation=portrait",
    updateTime: "2026-08-09",
    description: "太阳急速老化，人类面临生存危机，联合政府启动移山计划，踏上宇宙流浪之旅。",
    isHot: true,
  },
  {
    id: "movie-2",
    title: "封神第二部：战火西岐",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    genre: "奇幻 / 动作 / 古装",
    duration: "156分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20mythological%20Chinese%20fantasy%20film%20poster%20with%20ancient%20warriors%2C%20dramatic%20battle%2C%20golden%20and%20red%20tones%2C%20epic%20cinematic%20poster&width=600&height=840&seq=poster-movie-2&orientation=portrait",
    updateTime: "2026-08-08",
    description: "殷商末年，姜子牙携封神榜下山，神魔大战一触即发。",
    isHot: true,
  },
  {
    id: "movie-3",
    title: "酱园弄",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "悬疑 / 犯罪 / 剧情",
    duration: "135分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20poster%20in%201940s%20Shanghai%2C%20film%20noir%20style%2C%20rainy%20alley%2C%20dark%20moody%20atmosphere%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-3&orientation=portrait",
    updateTime: "2026-08-06",
    description: "四十年代上海，一桩离奇命案背后隐藏着复杂的利益纠葛与人性考验。",
    isHot: true,
  },
  {
    id: "movie-4",
    title: "孤注一掷2",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    genre: "犯罪 / 剧情 / 惊悚",
    duration: "142分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20crime%20thriller%20movie%20poster%20about%20cyber%20fraud%2C%20digital%20screens%2C%20tense%20atmosphere%2C%20dark%20red%20and%20black%20tones%2C%20cinematic%20poster%20design&width=600&height=840&seq=poster-movie-4&orientation=portrait",
    updateTime: "2026-08-05",
    description: "揭露境外网络诈骗全产业链内幕，一场惊心动魄的生存之战。",
    isHot: false,
  },
  {
    id: "movie-5",
    title: "三大队",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    genre: "剧情 / 犯罪 / 动作",
    duration: "138分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20police%20drama%20movie%20poster%20with%20three%20determined%20officers%2C%20urban%20night%20setting%2C%20gritty%20realistic%20style%2C%20dark%20blue%20tones%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-5&orientation=portrait",
    updateTime: "2026-08-03",
    description: "三名刑警追凶十二年，只为揭开真相，还原正义。",
    isHot: false,
  },
  {
    id: "movie-6",
    title: "年会不能停2",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    genre: "喜剧 / 剧情",
    duration: "128分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20movie%20poster%20about%20office%20workers%2C%20colorful%20festive%20atmosphere%2C%20corporate%20party%20theme%2C%20bright%20warm%20tones%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-6&orientation=portrait",
    updateTime: "2026-08-01",
    description: "一场荒诞的公司年会，引发了一连串啼笑皆非的故事。",
    isHot: false,
  },
  {
    id: "movie-7",
    title: "深海2",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 奇幻 / 冒险",
    duration: "126分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%20with%20underwater%20fantasy%20world%2C%20vibrant%20colors%2C%20magical%20sea%20creatures%2C%20ink%20painting%20style%2C%20dreamy%20atmosphere%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-7&orientation=portrait",
    updateTime: "2026-07-28",
    description: "一个少女在神秘海底世界展开奇幻冒险，追寻自我与梦想。",
    isHot: false,
  },
  {
    id: "movie-8",
    title: "热辣滚烫2",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    genre: "剧情 / 运动 / 喜剧",
    duration: "140分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20drama%20movie%20poster%20about%20boxing%20and%20self-discovery%2C%20warm%20lighting%2C%20inspiring%20atmosphere%2C%20red%20and%20golden%20tones%2C%20cinematic%20poster%20design&width=600&height=840&seq=poster-movie-8&orientation=portrait",
    updateTime: "2026-07-25",
    description: "一个普通女性通过学习拳击重拾自信，开启热辣滚烫的人生。",
    isHot: false,
  },
  {
    id: "movie-9",
    title: "飞驰人生3",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "喜剧 / 运动 / 剧情",
    duration: "136分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20racing%20comedy%20movie%20poster%20with%20race%20cars%20on%20track%2C%20dynamic%20action%2C%20desert%20landscape%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-9&orientation=portrait",
    updateTime: "2026-07-22",
    description: "老赛车手重返赛场，用速度与激情书写飞驰人生的新篇章。",
    isHot: false,
  },
  {
    id: "movie-10",
    title: "第二十条",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    genre: "剧情 / 法律 / 社会",
    duration: "152分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20legal%20drama%20movie%20poster%20with%20courtroom%20scenes%2C%20solemn%20atmosphere%2C%20dark%20wood%20tones%2C%20professional%20composition%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-10&orientation=portrait",
    updateTime: "2026-07-20",
    description: "围绕刑法第二十条正当防卫条款展开的法律与人性的深层探讨。",
    isHot: false,
  },
  {
    id: "movie-11",
    title: "长空之王2",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    genre: "动作 / 剧情 / 军事",
    duration: "145分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20military%20aviation%20movie%20poster%20with%20fighter%20jets%20in%20sky%2C%20dramatic%20clouds%2C%20patriotic%20theme%2C%20blue%20sky%20and%20silver%20planes%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-11&orientation=portrait",
    updateTime: "2026-07-18",
    description: "中国试飞员用生命丈量极限，守护蓝天长城的壮烈故事。",
    isHot: false,
  },
  {
    id: "movie-12",
    title: "消失的她2",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    genre: "悬疑 / 犯罪 / 剧情",
    duration: "132分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20suspense%20thriller%20movie%20poster%20with%20mysterious%20female%20silhouette%2C%20tropical%20island%20atmosphere%2C%20dark%20and%20moody%2C%20red%20accents%2C%20cinematic%20poster&width=600&height=840&seq=poster-movie-12&orientation=portrait",
    updateTime: "2026-07-15",
    description: "度假胜地发生离奇失踪案，妻子消失的背后隐藏着骇人真相。",
    isHot: false,
  },
];

export const tvList = [
  {
    id: "tv-1",
    title: "长安的荔枝",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 剧情 / 历史",
    duration: "40集",
    poster: "https://readdy.ai/api/search-image?query=A%20Tang%20Dynasty%20TV%20drama%20poster%20with%20ancient%20Chinese%20city%2C%20traditional%20clothing%2C%20warm%20golden%20tones%2C%20elegant%20historical%20drama%20poster%20design&width=600&height=840&seq=poster-tv-1&orientation=portrait",
    updateTime: "2026-08-05",
    description: "大唐天宝年间，小吏李善德奉命从岭南运送新鲜荔枝到长安。",
    isHot: true,
  },
  {
    id: "tv-2",
    title: "大奉打更人",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 奇幻 / 悬疑",
    duration: "36集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20drama%20poster%20with%20nightwatchman%20in%20traditional%20uniform%2C%20ancient%20city%20at%20night%2C%20mysterious%20atmosphere%2C%20dark%20and%20warm%20contrast%2C%20drama%20poster&width=600&height=840&seq=poster-tv-2&orientation=portrait",
    updateTime: "2026-08-04",
    description: "现代警校生穿越到大奉王朝，凭借刑侦知识破解离奇案件。",
    isHot: true,
  },
  {
    id: "tv-3",
    title: "庆余年第二季",
    rating: 9.0,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 权谋 / 喜剧",
    duration: "36集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20drama%20poster%20with%20scholarly%20man%20in%20luxurious%20robes%2C%20palace%20setting%2C%20rich%20golden%20tones%2C%20elegant%20historical%20drama%20poster&width=600&height=840&seq=poster-tv-3&orientation=portrait",
    updateTime: "2026-08-02",
    description: "范闲从北齐归来，京都风云变幻，更大的阴谋正在酝酿。",
    isHot: true,
  },
  {
    id: "tv-4",
    title: "异人之下 第二季",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "奇幻 / 动作 / 都市",
    duration: "更新至18集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20urban%20fantasy%20drama%20poster%20with%20superpowered%20characters%2C%20modern%20city%20background%2C%20dynamic%20action%2C%20neon%20and%20dark%20contrast%2C%20drama%20poster&width=600&height=840&seq=poster-tv-4&orientation=portrait",
    updateTime: "2026-08-01",
    description: "隐藏在现代都市中的异人世界，超能力者之间的精彩对决。",
    isHot: false,
  },
  {
    id: "tv-5",
    title: "天启异闻录",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    genre: "悬疑 / 古装 / 奇幻",
    duration: "24集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20mystery%20drama%20poster%20set%20in%20ancient%20times%2C%20supernatural%20elements%2C%20dark%20forest%2C%20mysterious%20atmosphere%2C%20misty%20landscape%2C%20drama%20poster&width=600&height=840&seq=poster-tv-5&orientation=portrait",
    updateTime: "2026-07-30",
    description: "明朝末年，诡异天启降临，一桩桩超自然事件揭开惊天秘密。",
    isHot: false,
  },
  {
    id: "tv-6",
    title: "狂飙时代",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "犯罪 / 剧情 / 扫黑",
    duration: "更新至32集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20crime%20drama%20poster%20about%20anti-corruption%2C%20urban%20night%20scene%2C%20tense%20atmosphere%2C%20dark%20blue%20and%20red%20contrast%2C%20drama%20poster%20design&width=600&height=840&seq=poster-tv-6&orientation=portrait",
    updateTime: "2026-07-28",
    description: "扫黑除恶专项斗争中，正邪较量二十年的人性史诗。",
    isHot: false,
  },
  {
    id: "tv-7",
    title: "繁花",
    rating: 9.1,
    year: 2025,
    region: "中国大陆",
    genre: "剧情 / 都市 / 年代",
    duration: "30集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20vintage%20cityscape%2C%20golden%20nostalgic%20tones%2C%20elegant%20composition%2C%20artistic%20drama%20poster&width=600&height=840&seq=poster-tv-7&orientation=portrait",
    updateTime: "2025-12-30",
    description: "九十年代上海，黄河路上风云际会，沪上儿女的奋斗与情感。",
    isHot: false,
  },
  {
    id: "tv-8",
    title: "三体",
    rating: 8.8,
    year: 2025,
    region: "中国大陆",
    genre: "科幻 / 剧情 / 悬疑",
    duration: "30集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20sci-fi%20drama%20poster%20based%20on%20Three%20Body%20Problem%2C%20cosmic%20scale%2C%20mysterious%20scientific%20elements%2C%20dark%20blue%20and%20white%20contrast%2C%20drama%20poster&width=600&height=840&seq=poster-tv-8&orientation=portrait",
    updateTime: "2025-12-15",
    description: "纳米科学家汪淼卷入神秘事件，揭开三体文明的宇宙秘密。",
    isHot: false,
  },
  {
    id: "tv-9",
    title: "长风渡",
    rating: 8.3,
    year: 2025,
    region: "中国大陆",
    genre: "古装 / 爱情 / 剧情",
    duration: "40集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20romance%20drama%20poster%20with%20couple%20in%20traditional%20clothing%2C%20ancient%20architecture%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20drama%20poster&width=600&height=840&seq=poster-tv-9&orientation=portrait",
    updateTime: "2025-11-20",
    description: "布商之女柳玉茹与纨绔顾九思先婚后爱的浪漫传奇。",
    isHot: false,
  },
  {
    id: "tv-10",
    title: "唐朝诡事录之西行",
    rating: 8.6,
    year: 2025,
    region: "中国大陆",
    genre: "悬疑 / 古装 / 奇幻",
    duration: "36集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20supernatural%20mystery%20drama%20poster%20set%20in%20Tang%20Dynasty%2C%20ancient%20road%20journey%2C%20mysterious%20creatures%2C%20dark%20atmospheric%2C%20drama%20poster&width=600&height=840&seq=poster-tv-10&orientation=portrait",
    updateTime: "2025-10-15",
    description: "唐朝探案小队西行路上遇到的诡异奇幻事件。",
    isHot: false,
  },
  {
    id: "tv-11",
    title: "我的阿勒泰",
    rating: 8.7,
    year: 2025,
    region: "中国大陆",
    genre: "剧情 / 生活 / 文艺",
    duration: "8集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20artistic%20drama%20poster%20set%20in%20Altay%20grasslands%2C%20vast%20natural%20landscape%2C%20nomadic%20lifestyle%2C%20warm%20sunlight%2C%20cinematic%20nature%20photography%2C%20drama%20poster&width=600&height=840&seq=poster-tv-11&orientation=portrait",
    updateTime: "2025-09-20",
    description: "在新疆阿勒泰的广袤草原上，一段关于成长、自由与爱的故事。",
    isHot: false,
  },
  {
    id: "tv-12",
    title: "漫长的季节",
    rating: 9.2,
    year: 2025,
    region: "中国大陆",
    genre: "悬疑 / 犯罪 / 剧情",
    duration: "12集(完结)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20suspense%20drama%20poster%20set%20in%20northeastern%20China%2C%20autumn%20landscape%2C%20dark%20mystery%20theme%2C%20nostalgic%201990s%20feel%2C%20artistic%20drama%20poster&width=600&height=840&seq=poster-tv-12&orientation=portrait",
    updateTime: "2025-08-15",
    description: "一桩跨越二十年的碎尸悬案，揭开东北小城的人间悲欢。",
    isHot: false,
  },
];

export const animeList = [
  {
    id: "anime-1",
    title: "哪吒之魔童闹海",
    rating: 9.2,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 奇幻 / 冒险",
    duration: "132分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%20with%20mythological%20young%20warrior%2C%20flaming%20hair%2C%20red%20silk%2C%20dynamic%20pose%2C%20vibrant%20colors%2C%20ink%20painting%20style%2C%20anime%20poster&width=600&height=840&seq=poster-anime-1&orientation=portrait",
    updateTime: "2026-08-07",
    description: "哪吒与敖丙的灵魂面临肉身重塑的考验，新的冒险即将展开。",
    isHot: true,
  },
  {
    id: "anime-2",
    title: "剑来",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 武侠 / 奇幻",
    duration: "更新至24集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20donghua%20poster%20with%20young%20swordsman%2C%20glowing%20sword%2C%20mountain%20landscape%2C%20ink%20wash%20style%2C%20ethereal%20atmosphere%2C%20anime%20poster%20design&width=600&height=840&seq=poster-anime-2&orientation=portrait",
    updateTime: "2026-08-03",
    description: "少年陈平安踏上修行之路，一剑在手，天下我有。",
    isHot: true,
  },
  {
    id: "anime-3",
    title: "凡人修仙传",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 仙侠 / 冒险",
    duration: "更新至126集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20xianxia%20donghua%20poster%20with%20cultivator%20in%20flowing%20robes%2C%20magical%20effects%2C%20ancient%20Chinese%20landscape%2C%20ethereal%20light%2C%20anime%20poster&width=600&height=840&seq=poster-anime-3&orientation=portrait",
    updateTime: "2026-08-02",
    description: "一个普通的山村少年韩立，凭借自身努力踏上修仙之路。",
    isHot: true,
  },
  {
    id: "anime-4",
    title: "星辰变 第六季",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 仙侠 / 奇幻",
    duration: "更新至8集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20xianxia%20donghua%20poster%20with%20starry%20sky%2C%20celestial%20being%2C%20magical%20energy%2C%20cosmic%20scale%2C%20purple%20and%20gold%20tones%2C%20anime%20poster&width=600&height=840&seq=poster-anime-4&orientation=portrait",
    updateTime: "2026-08-01",
    description: "秦羽在神界继续成长，星辰变的奥秘逐渐揭晓。",
    isHot: false,
  },
  {
    id: "anime-5",
    title: "斗破苍穹 年番",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 玄幻 / 热血",
    duration: "更新至98集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20donghua%20poster%20with%20young%20warrior%2C%20flame%20powers%2C%20epic%20battle%20pose%2C%20desert%20background%2C%20fiery%20orange%20tones%2C%20anime%20poster&width=600&height=840&seq=poster-anime-5&orientation=portrait",
    updateTime: "2026-07-31",
    description: "天才少年萧炎从云端跌落谷底后的逆袭之路。",
    isHot: false,
  },
  {
    id: "anime-6",
    title: "完美世界",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 玄幻 / 冒险",
    duration: "更新至186集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20donghua%20poster%20with%20ancient%20tribal%20warrior%2C%20primordial%20beasts%2C%20wild%20landscape%2C%20epic%20scale%2C%20earthy%20tones%2C%20anime%20poster&width=600&height=840&seq=poster-anime-6&orientation=portrait",
    updateTime: "2026-07-29",
    description: "石昊在大荒中崛起，一步步走向至强者之路。",
    isHot: false,
  },
  {
    id: "anime-7",
    title: "一念永恒 第三季",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 仙侠 / 喜剧",
    duration: "更新至12集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20xianxia%20donghua%20poster%20with%20funny%20young%20cultivator%2C%20magical%20items%2C%20colorful%20ancient%20Chinese%20setting%2C%20light%20humorous%20style%2C%20anime%20poster&width=600&height=840&seq=poster-anime-7&orientation=portrait",
    updateTime: "2026-07-27",
    description: "白小纯的修仙搞笑日常，怕死又爱出风头的另类修仙路。",
    isHot: false,
  },
  {
    id: "anime-8",
    title: "遮天",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 仙侠 / 科幻",
    duration: "更新至52集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20cosmic%20xianxia%20donghua%20poster%20with%20stars%20and%20planets%2C%20ancient%20ruins%20in%20space%2C%20mysterious%20artifacts%2C%20vast%20cosmic%20scale%2C%20anime%20poster&width=600&height=840&seq=poster-anime-8&orientation=portrait",
    updateTime: "2026-07-25",
    description: "叶凡从地球被带到北斗星域，揭开宇宙深处的修仙秘密。",
    isHot: false,
  },
  {
    id: "anime-9",
    title: "仙逆",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 仙侠 / 剧情",
    duration: "更新至86集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20dark%20xianxia%20donghua%20poster%20with%20determined%20cultivator%2C%20stormy%20sky%2C%20lightning%20effects%2C%20dark%20and%20intense%20atmosphere%2C%20anime%20poster%20design&width=600&height=840&seq=poster-anime-9&orientation=portrait",
    updateTime: "2026-07-23",
    description: "王林以凡人之躯逆天改命，书写一段充满血与泪的修仙传奇。",
    isHot: false,
  },
  {
    id: "anime-10",
    title: "神印王座",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 奇幻 / 冒险",
    duration: "更新至144集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20donghua%20poster%20with%20knight%20in%20armor%2C%20magical%20throne%2C%20medieval%20fantasy%20setting%2C%20epic%20battle%2C%20anime%20poster%20design&width=600&height=840&seq=poster-anime-10&orientation=portrait",
    updateTime: "2026-07-21",
    description: "少年龙皓晨为守护人类而战，一步步登上神印王座。",
    isHot: false,
  },
  {
    id: "anime-11",
    title: "绝世唐门",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 玄幻 / 冒险",
    duration: "更新至68集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20donghua%20poster%20with%20young%20spirit%20master%2C%20glowing%20martial%20spirit%2C%20magical%20academy%2C%20vibrant%20colors%2C%20anime%20poster%20design&width=600&height=840&seq=poster-anime-11&orientation=portrait",
    updateTime: "2026-07-19",
    description: "霍雨浩在史莱克学院开启魂师之路，创造属于他的绝世传奇。",
    isHot: false,
  },
  {
    id: "anime-12",
    title: "眷思量 第二季",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 古风 / 悬疑",
    duration: "更新至16集",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20beautiful%20ancient%20style%20donghua%20poster%20with%20mysterious%20island%2C%20exquisite%20character%20design%2C%20flowing%20silk%20fabrics%2C%20dreamy%20atmosphere%2C%20anime%20poster&width=600&height=840&seq=poster-anime-12&orientation=portrait",
    updateTime: "2026-07-17",
    description: "思量岛上隐藏的秘密与恩怨情仇逐渐浮出水面。",
    isHot: false,
  },
];

export const varietyList = [
  {
    id: "variety-1",
    title: "乘风破浪的姐姐 第六季",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 音乐 / 竞演",
    duration: "更新至第10期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20variety%20show%20poster%20with%20female%20celebrities%20on%20stage%2C%20glamorous%20performance%2C%20stage%20lights%2C%20colorful%20vibrant%2C%20variety%20show%20poster%20design&width=600&height=840&seq=poster-variety-1&orientation=portrait",
    updateTime: "2026-08-06",
    description: "30+姐姐再次集结，用舞台重新定义女性力量。",
    isHot: true,
  },
  {
    id: "variety-2",
    title: "脱口秀大会 第七季",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    genre: "脱口秀 / 喜剧 / 竞演",
    duration: "更新至第8期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20talk%20show%20poster%20with%20comedian%20on%20stage%20with%20microphone%2C%20spotlight%2C%20comedy%20club%20atmosphere%2C%20bright%20stage%20design%2C%20variety%20poster&width=600&height=840&seq=poster-variety-2&orientation=portrait",
    updateTime: "2026-08-04",
    description: "全国顶尖脱口秀演员用幽默段子点燃舞台。",
    isHot: true,
  },
  {
    id: "variety-3",
    title: "奔跑吧 第十四季",
    rating: 8.0,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 游戏 / 户外",
    duration: "更新至第12期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20outdoor%20variety%20show%20poster%20with%20celebrities%20running%2C%20outdoor%20adventure%2C%20colorful%20energetic%2C%20sports%20theme%2C%20variety%20show%20poster&width=600&height=840&seq=poster-variety-3&orientation=portrait",
    updateTime: "2026-07-30",
    description: "跑男团再度出发，在欢乐与挑战中传递奔跑精神。",
    isHot: false,
  },
  {
    id: "variety-4",
    title: "这就是街舞 第七季",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 舞蹈 / 竞演",
    duration: "更新至第14期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20street%20dance%20show%20poster%20with%20dancers%20in%20dynamic%20moves%2C%20urban%20street%20style%2C%20neon%20lights%2C%20hip%20hop%20culture%2C%20variety%20show%20poster&width=600&height=840&seq=poster-variety-4&orientation=portrait",
    updateTime: "2026-07-28",
    description: "全国顶尖舞者同台竞技，用舞蹈诠释热爱与坚持。",
    isHot: false,
  },
  {
    id: "variety-5",
    title: "向往的生活 第九季",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 生活 / 慢综艺",
    duration: "更新至第14期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20slow-paced%20variety%20show%20poster%20with%20countryside%20house%2C%20farm%20life%2C%20warm%20natural%20lighting%2C%20peaceful%20rural%20scene%2C%20variety%20poster&width=600&height=840&seq=poster-variety-5&orientation=portrait",
    updateTime: "2026-07-20",
    description: "在田园生活中感受简单的美好，回归向往的生活方式。",
    isHot: false,
  },
  {
    id: "variety-6",
    title: "歌手 2026",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "音乐 / 竞演 / 真人秀",
    duration: "更新至第12期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20music%20competition%20show%20poster%20with%20singer%20on%20grand%20stage%2C%20dramatic%20lighting%2C%20orchestra%2C%20elegant%20atmosphere%2C%20music%20show%20poster&width=600&height=840&seq=poster-variety-6&orientation=portrait",
    updateTime: "2026-07-15",
    description: "华语乐坛顶级歌手同台竞技，以歌声征服舞台。",
    isHot: false,
  },
  {
    id: "variety-7",
    title: "密室大逃脱 第六季",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 解谜 / 冒险",
    duration: "更新至第8期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20escape%20room%20variety%20show%20poster%20with%20dark%20mysterious%20room%2C%20puzzle%20elements%2C%20celebrities%20looking%20scared%2C%20thriller%20vibe%2C%20variety%20poster&width=600&height=840&seq=poster-variety-7&orientation=portrait",
    updateTime: "2026-07-12",
    description: "明星嘉宾在精心设计的密室中解谜逃生，笑料与惊吓不断。",
    isHot: false,
  },
  {
    id: "variety-8",
    title: "最强大脑 第十二季",
    rating: 8.1,
    year: 2026,
    region: "中国大陆",
    genre: "竞演 / 智力 / 科学",
    duration: "更新至第10期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20brain%20competition%20show%20poster%20with%20futuristic%20set%2C%20puzzle%20visuals%2C%20digital%20brain%2C%20scientific%20atmosphere%2C%20variety%20poster%20design&width=600&height=840&seq=poster-variety-8&orientation=portrait",
    updateTime: "2026-07-10",
    description: "全国最强大脑汇聚一堂，挑战人类智力极限。",
    isHot: false,
  },
  {
    id: "variety-9",
    title: "中国好声音 2026",
    rating: 8.0,
    year: 2026,
    region: "中国大陆",
    genre: "音乐 / 选秀 / 竞演",
    duration: "更新至第6期",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20singing%20competition%20show%20poster%20with%20turning%20chairs%2C%20spotlight%20on%20stage%2C%20microphone%2C%20music%20notes%2C%20dramatic%20stage%20design%2C%20variety%20poster&width=600&height=840&seq=poster-variety-9&orientation=portrait",
    updateTime: "2026-07-08",
    description: "四位导师转身抢人，发现华语乐坛下一个好声音。",
    isHot: false,
  },
  {
    id: "variety-10",
    title: "哈哈哈哈哈 第五季",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 旅行 / 喜剧",
    duration: "更新至第10期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20travel%20comedy%20variety%20show%20poster%20with%20celebrities%20in%20road%20trip%2C%20funny%20expressions%2C%20scenic%20landscape%2C%20bright%20joyful%20atmosphere%2C%20variety%20poster&width=600&height=840&seq=poster-variety-10&orientation=portrait",
    updateTime: "2026-07-05",
    description: "明星嘉宾踏上公路旅行，在欢笑中体验真实生活。",
    isHot: false,
  },
  {
    id: "variety-11",
    title: "明星大侦探 第十季",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 推理 / 悬疑",
    duration: "更新至第12期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20mystery%20detective%20show%20poster%20with%20magnifying%20glass%2C%20crime%20scene%20elements%2C%20dark%20mysterious%20atmosphere%2C%20detective%20theme%2C%20variety%20poster&width=600&height=840&seq=poster-variety-11&orientation=portrait",
    updateTime: "2026-06-30",
    description: "明星侦探团推理破案，谁是真正的凶手？",
    isHot: false,
  },
  {
    id: "variety-12",
    title: "极限挑战 第十一季",
    rating: 8.1,
    year: 2026,
    region: "中国大陆",
    genre: "真人秀 / 游戏 / 户外",
    duration: "更新至第12期(完)",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20challenge%20variety%20show%20poster%20with%20celebrities%20in%20urban%20setting%2C%20game%20elements%2C%20dynamic%20action%2C%20city%20landscape%2C%20variety%20show%20poster&width=600&height=840&seq=poster-variety-12&orientation=portrait",
    updateTime: "2026-06-25",
    description: "这就是命！极限男人帮在城市中展开智慧与体力的较量。",
    isHot: false,
  },
];